"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketClientConnectorRpcRemote = void 0;
const utils_1 = require("@streamr/utils");
const RpcRemote_1 = require("../../dht/contact/RpcRemote");
const identifiers_1 = require("../../identifiers");
const logger = new utils_1.Logger(module);
class WebsocketClientConnectorRpcRemote extends RpcRemote_1.RpcRemote {
    async requestConnection() {
        logger.trace(`Requesting WebSocket connection from ${(0, identifiers_1.toNodeId)(this.getLocalPeerDescriptor())}`);
        const request = {};
        const options = this.formDhtRpcOptions();
        return this.getClient().requestConnection(request, options);
    }
}
exports.WebsocketClientConnectorRpcRemote = WebsocketClientConnectorRpcRemote;
//# sourceMappingURL=WebsocketClientConnectorRpcRemote.js.map